import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { apiRequest } from "../../services";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import { CheckCircleOutline, Error } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import "./Claims.css";
import { Dialog, DialogTitle, DialogContent, Typography } from '@mui/material';


const Claims = () => {
  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState(""); 
  const [pending, setPending] = useState(true);
  const [docStatus, setDocStatus] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const userData = useSelector((state) => state.users);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const location = useLocation();
  const insuranceId = location.state?.insuranceId;
  console.log("insurance id is", insuranceId);
  const [openModal, setOpenModal] = useState(false);
  const [selectedComment, setSelectedComment] = useState('');


  const fetchDocStatus = async () => {
    try {
      setLoading(true);
      const requestData = {
        serviceReference: "GET_DECLARATION_ACCOUNT",
        requestBody: insuranceId,
      };

      const response = await apiRequest(
        "GATEWAY",
        "",
        "POST",
        requestData,
        userData.token,
        dispatch,
        navigate
      );
      console.log("response is ", response);
      if (response && response.status === 200) {
        setDocStatus(response.body.data);
        setRows(response.body.data);
      } else {
        console.error("API request failed:", response);
        // toast.error(t("failedToFetchClaims"));
      }
    } catch (error) {
      console.error("Error fetching claims:", error);
      // toast.error(t("failedToFetchClaims"));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocStatus();
  }, []);

  const filteredDocStatus = docStatus.filter((item) => {
    const searchLower = searchTerm.toLowerCase();
    
    const statusFilterMatch = !statusFilter || 
      (item.claimDeclaration?.status === statusFilter);
    
    if (!searchTerm) {
      return statusFilterMatch;
    }
    
    const textFields = Object.values(item).some(
      (field) =>
        typeof field === "string" &&
        field.toLowerCase().includes(searchLower)
    );
    
    const claimFields = item.claimDeclaration && Object.values(item.claimDeclaration).some(
      (field) =>
        typeof field === "string" &&
        field.toLowerCase().includes(searchLower)
    );

    return statusFilterMatch && (textFields || claimFields);
  });

  const columns = [
    {
      name: <span className="column-header">{t("claimType")}</span>,
      selector: (row) => row.claimDeclaration.claimName,
      sortable: true,
      left: true,
      reorder: true,
    },
    {
      name: <span className="column-header">{t("dateValidation")}</span>,
      selector: (row) =>
        row.claimDeclaration?.processedAndValidatedDate
          ? row.claimDeclaration.processedAndValidatedDate
          : "N/A",
      sortable: true,
      reorder: true,
    },
    {
      name: <span className="column-header">{t("declaredDate")}</span>,
      selector: (row) => row.claimDeclaration.declaredDate,
      sortable: true,
      reorder: true,
    },
    {
      name: <span className="column-header">{t("Commentaire assureur")}</span>,
      selector: (row) => {
        const comment = row.claimDeclaration?.userCommentary || "N/A";
        return comment.length > 50 ? (
          <span
            style={{ color: "#1976d2", cursor: "pointer" }}
            onClick={() => handleOpenModal(comment)}
          >
            {comment.slice(0, 50)}...
          </span>
        ) : (
          comment
        );
      },
      sortable: true,
      reorder: true,
    },
    // {
    //   name: <span className="column-header">{t("Commentaire assureur")}</span>,
    //   selector: (row) =>
    //     row.claimDeclaration?.userCommentary
    //       ? row.claimDeclaration.userCommentary
    //       : "N/A",
    //   sortable: true,
    //   reorder: true,
    // },
    {
      name: <span className="column-header">{t("status")}</span>,
      cell: (row) => (
        <>
          {row.claimDeclaration.status === "SUCCESSFUL" ? (
            <span
              className="text-success d-flex align-items-center"
              style={{ gap: "0.5rem" }}
            >
              <strong>SUCCESSFUL</strong>
              <CheckCircleOutline />
            </span>
          ) : row.claimDeclaration.status === "REJECTED" ? (
            <span
              className="text-danger d-flex align-items-center"
              style={{ gap: "0.5rem" }}
            >
              <strong>REJECTED</strong>
              <Error />
            </span>
          ) : (
            <span
              className="text-warning d-flex align-items-center"
              style={{ gap: "0.5rem" }}
            >
              <strong>PENDING</strong>
              <HourglassEmptyIcon />
            </span>
          )}
        </>
      ),
      sortable: true,
      reorder: true,
    },
  ];

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPending(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);

  const handleRowSelected = (state) => {
    setSelectedRows(state.selectedRows);
  };

  const handleOpenModal = (comment) => {
    setSelectedComment(comment);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedComment('');
  };

  return (
    <div className="cards p-4">
      <div className="d-flex justify-content-between flex-wrap align-items-center">
        <div className="mb-2">
          <h2 className="h4 mb-1">
            {t("claimsDeclaration")}{" "}
            <span className="insurance-code small">
              ({userData.users.clientDetails.insuranceId})
            </span>
          </h2>
        </div>
        <div
          className="profiles-button-container"
        >
          <Button
            onClick={() => navigate("/profiles")}
            className="profiles-action-button mb-2"
          >
            {t("completeSubscription")}
          </Button>
          <Button
            onClick={() => navigate("/beneficiary")}
            className="profiles-action-button mb-2"
          >
            {t("addBeneficiary")}
          </Button>
        </div>
      </div>

      <div className="card p-4 mt-4">
        <div className="d-flex justify-content-start mb-3">
          <h4 className="h5">{t("listOfClaims")}</h4>
        </div>

        <DataTable
          title=""
          columns={columns}
          data={filteredDocStatus} 
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[5, 10, 20, 30]}
          selectableRows
          onSelectedRowsChange={handleRowSelected}
          highlightOnHover
          pointerOnHover
          responsive
          subHeader
          progressPending={pending}
          subHeaderComponent={
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div className="d-flex align-items-center mb-2 mb-md-0 gap-3">
                <select
                  className="form-select form-select-sm"
                  style={{ minWidth: "150px" }}
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="">{t("allStatus") || "Tous les statuts"}</option>
                  <option value="SUCCESSFUL">SUCCESSFUL</option>
                  <option value="REJECTED">REJECTED</option>
                  <option value="PENDING">PENDING</option>
                </select>

               

                {(searchTerm || statusFilter) && (
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => {
                      setSearchTerm("");
                      setStatusFilter("");
                    }}
                    title="Réinitialiser les filtres"
                  >
                    ✕
                  </button>
                )}

                {(searchTerm || statusFilter) && (
                  <small className="text-muted">
                    {filteredDocStatus.length} résultat(s) trouvé(s)
                  </small>
                )}
              </div>
            </div>
          }
        />
      </div>

      <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="sm">
        <DialogTitle>Commentaire complet</DialogTitle>
        <DialogContent>
          <Typography>{selectedComment}</Typography>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Claims;